import { TickFormatter } from '@visx/axis'
import { ScaleOrdinal } from '@visx/vendor/d3-scale'
import { ReactNode } from 'react'

export type OpeningHours = {
    open: string
    close: string
    duration?: unknown
}

export type TimeString = `${string}:${string}`

export const string_ToTimeString = (time: string): TimeString => {
    const [h, m] = time.split(':')
    return `${h}:${m}` as TimeString
}

export type MarginProps = {
    top?: number
    right?: number
    bottom?: number
    left?: number
}

export type GanttBar<T = object> = {
    start: TimeString // e.g., '07:30'
    end: TimeString // e.g., '09:00'
    type: string // e.g., 'Surgery Group 1'
    // could be other meta data and properties about the bar (e.g. Surgery)
    nested_start?: TimeString
    nested_end?: TimeString
} & T

export type ChartDataItem<T = unknown> = {
    category?: string // e.g., 'Category A'
    // could be other meta data and properties about the row (e.g. day or OperatingRoom)
    bars: Record<string, GanttBar<T>>
    /** Overrides the chart-level `openingHours` for this row. */
    openingHours?: OpeningHours
}

export type ChartData<T = unknown> = Record<string, ChartDataItem<T>> // e.g., { '2025-04-01': { category: 'Category A', bars: { ... } } }

export type GanttChartProps<T = unknown> = {
    data: ChartData<T>
    width?: number
    height?: number
    axisFormatter?: TickFormatter<string>
    ordinalColorScaleOverride?: ScaleOrdinal<string, string>
    margin?: MarginProps
    hoveredKey?: string
    hoverContent?: (hoveredItem: GanttBar<T>, rowKey: string) => ReactNode
    rowHoverContent?: (rowKey: string) => ReactNode
    /** If defined, areas outside this opening hours window are hatched. Rows without their own or a chart-level opening hours are left unhatched. */
    openingHours?: OpeningHours
}
